import React from 'react';
import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Row from 'react-bootstrap/Row';
import * as httpService from '../../services/HTTPService';
// import { redirect } from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../../context/authContext';

const AccountComponent = () => {
    const { t, i18n } = useTranslation();
    const accountDetails = i18n.exists("forms.accountDetails") ? t('forms.accountDetails') : "Детайли за акаунта";
    const accountLoginLbl = i18n.exists("forms.accountLoginLbl") ? t('forms.accountLoginLbl') : "Влез";
    const [validated, setValidated] = useState(false);
    const [visiblePass, setVisiblePass] = useState(false);

    const googleProfile: any = localStorage.getItem('googleProfile');
    let googleUser: any = googleProfile ? JSON.parse(googleProfile) : null;

    const { user } = useAuth();
    const emailUser: any = user;
    const emailUserObj: any = JSON.parse(emailUser); 

    const userExists = user || googleUser;
    let userEmailString = "";
    if(userExists) {
        if(user) {
            // email user
            userEmailString = emailUserObj.email;
        }
        else {
            userEmailString = googleUser.email;
        }
    }
    const defaultFormData = {
        email: "",
        password: "",
        staySigned: false
    }
    let [loginForm, setLoginForm] = useState(defaultFormData);

    const handleSubmit: React.FormEventHandler<HTMLFormElement> = (event) => {
        event.preventDefault();
        event.stopPropagation();
        const form: any = event.currentTarget;
        let loginData: any  = {...loginForm};
        const data:any = new FormData(event.currentTarget)
        //let formObject = Object.fromEntries(data.entries())
        let d = data.entries();
        for (let [key, value] of d) {
            loginData[key] = value;
            console.log(key, value);
        }
        if(form[2].id === "staySigned") {
            const isChecked = form[2].checked ? true : false;
            loginData['staySigned'] = isChecked;
        }
        loginForm = loginData;
        setLoginForm(loginData);
        
        if (form.checkValidity() === true) {
            loginUser(loginForm);
        }
        setValidated(true);
    };

    const loginUser = (user: any) => {
        console.log(user);
        httpService.loginUser(JSON.stringify(user)).then((res) => {
            if(res) {
                console.log(res);
                if(res.data) {
                    // TODO: get the token from the "data" object
                    window.location.href = "/";
                }
            }
        })
        .catch((err) => {
            console.log(err);
            let msg = err.response.data ? err.response.data: t('forms.commonErrMsg');
            if(msg === "Invalid credentials.") {
                msg = t('forms.invalidCredentials')
            }
            toast.error(msg);
        })
    }

//   const togglePass = () => {
//     setVisiblePass(!visiblePass);
//   }

    return <div>
        <h3>{accountDetails}</h3>

        <div>
            <ToastContainer position="top-center"
 />
            <Form noValidate validated={validated} onSubmit={handleSubmit}>
                <Row className="mb-3">
                    {userExists ? (
                        <Form.Group as={Col} md="12" controlId="email" className='check populated'>
                            <Form.Label>{t('forms.email')}*</Form.Label>
                            <Form.Control 
                                type="email"
                                name="email"
                                value={userEmailString}
                                disabled
                            />
                            <span className='checkmark'></span>
                            <Form.Control.Feedback type="invalid">
                            {t('forms.validEmailError')}
                            </Form.Control.Feedback>
                        </Form.Group>
                    ) : (
                        <>
                            <Form.Group as={Col} md="12" controlId="email" className='check'>
                                <Form.Label>{t('forms.email')}</Form.Label>
                                <Form.Control 
                                    type="email"
                                    name="email"
                                    required
                                />
                                <span className='checkmark'></span>
                                <Form.Control.Feedback type="invalid">
                                {t('forms.validEmailError')}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} md="12" controlId="validationCustom07" className='pass-group check'>
                                <Form.Label>{t('forms.password')}*</Form.Label>
                                <Form.Control type={visiblePass ? "text" : "password"} name="password" required />
                                {/* <span className='showPassBtn' onClick={togglePass}></span> */}
                                <span className='checkmark'></span>
                                <Form.Control.Feedback type="invalid">
                                    {t('forms.requiredFieldError', { field: t('forms.password')})}
                                </Form.Control.Feedback>
                            </Form.Group>
                            <Form.Group as={Col} xs="12" controlId="validationCustom08" className='flex-box account-login'>
                                <a className='brand-link' href="/register">{t('forms.signUpAccount')}</a>
                                <div className='align-right btn-out margin-0'>
                                    <Button type="submit" className='login-btn'>{accountLoginLbl}</Button>
                                </div>
                            </Form.Group>
                        </>
                    )}
                </Row>
            </Form>
        </div>
    </div>
}

export default AccountComponent;